






import { defineComponent } from '@nuxtjs/composition-api';
import { useLocales, usePage } from '@/composables';
import { Pages, PagesLinks } from '@/types';
import { DcwSuccessStoriesList } from '@organisms';
import { DcwListingPage } from '@/components/Layouts/ListingPage/DcwListingPage.vue';
import { getHeadlineWithExtraContent } from '@/helpers';
import { successStoriesService } from '@/service/model';

export const offers = defineComponent({
  components: { DcwSuccessStoriesList, DcwListingPage },
  layout: 'Default',
  setup() {
    const { translation } = useLocales();
    const { content: stories } = successStoriesService;

    usePage({
      data: Pages.SUCCESS_STORIES,
      breadcrumbs: [
        { name: translation.pagesNames.home, url: PagesLinks.HOME },
        { name: translation.pagesNames.career, url: PagesLinks.CAREER },
        { name: translation.pagesNames.successStories, url: PagesLinks.SUCCESS_STORIES }
      ]
    });

    const heroHeadlineContent = {
      ...translation.listings.successStories,
      headline: getHeadlineWithExtraContent(translation.listings.successStories.headline, stories.length)
    };

    return { stories, PagesLinks, heroHeadlineContent };
  },
  nuxtI18n: {
    locales: ['en']
  },
  head: {}
});

export default offers;
